<template>
  <OareContentView title="Tutorial">
    <div class="text-title-large font-weight-regular">
      <p>
        Welcome to the Old Assyrian Research Environment. This is an ongoing
        project, and a number of things are still in development. Here we've
        gathered a few notes on how to get the most out of OARE.
      </p>

      <p>
        At present, the website has a few more than 8000 published texts
        included in one form or another. Right now, only basic transliterations
        are available. A few properties are included at the top under the title
        of the text. Fuller bibliographic information and properties are
        planned.
      </p>

      <p>
        We will be making a number of areas more public in the coming year, but
        a not for now. You'll find a 'Dictionary" search in the Search Page.
        Enter either an English translation word, or an Akkadian lemma and
        you'll get results. At present a link appears to get more information
        about the word, but this will just take you back to the front page.
        That's the behavior for now unto we render more features public.
      </p>

      <p>
        Once you are at a text, there are a number of things you can do. Click
        on any word in the transliteration. If that particular word in that
        particular text has been connected to the dictionary, it will display in
        a popup.
      </p>

      <img src="@/assets/tutorial/tutorialPic1.png" />

      <p>
        The lemma, along with a definition, and some properties will display,
        and beneath that the particular form of the word as linked to the
        dictionary. In the example above, KÙ.BABBAR from the first line of the
        text has been identified as the singular accusative form kaspam and that
        form displays below the other information, with all currently indexed
        spellings, and in parentheses the number of times that spelling has been
        identified in the corpus and linked to the dictionary. If you click on
        one of those numbers, then a list of all the spellings, with some
        context for each will appear.
      </p>

      <img src="@/assets/tutorial/tutorialPic2.png" />

      <p>
        From here, if you would like to be able to see the relevant text
        displayed click on the title of the text, which will navigate to a
        display of that text.
      </p>

      <p>
        Essentially, if you sense something is a link, try clicking on it, and
        see if you can get something. Over time, more things will work.
      </p>

      <p>Thanks for your interest, Ed Stratford</p>
    </div>
  </OareContentView>
</template>
